module.exports = __webpack_public_path__ + "static/media/facial-recognition-mockup.280541c9.png";